import { Injectable } from '@angular/core';
import { NgxsOnInit, Selector, State, StateContext } from '@ngxs/store';
import { DeviceDetectorService, DeviceInfo } from 'ngx-device-detector';

export type DeviceStateModel = DeviceInfo;

export type DeviceStateContext = StateContext<DeviceStateModel>;

@State<DeviceStateModel>({
  name: 'deviceInfo',
  defaults: {} as DeviceInfo,
})
@Injectable()
export class DeviceState implements NgxsOnInit {
  constructor(private deviceInfoService: DeviceDetectorService) {}

  ngxsOnInit(ctx: DeviceStateContext) {
    const info = this.deviceInfoService.getDeviceInfo();

    ctx.setState(info);
  }

  @Selector([DeviceState])
  static isMac(state: DeviceStateModel) {
    return state.os === 'Mac';
  }

  @Selector([DeviceState])
  static isWindows(state: DeviceStateModel) {
    return state.os === 'Windows';
  }
}
